export default function convertToQueryString (params) {
    const queryString = new URLSearchParams(params).toString();
    return queryString
}